import angular from 'angular';
import { MeurhSolicitacoesalteracoesvtsService } from './solicitacoesalteracoesvts.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const MeurhSolicitacoesalteracoesvtsListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhSolicitacoesalteracoesvtsService',
                'ListagemService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhSolicitacoesalteracoesvtsService,
                    listagemService: ListagemService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        liberadoTela: (arg: string) => boolean
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('meurh_solicitacoesalteracoesvts'));
                    }

                    return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                            const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                            const mesmoEstabelecimento = data.estabelecimento.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                            const deveRedirecionar = (
                                (visibilidadeLiberada && !empresaNoGrupo) ||
                                (!visibilidadeLiberada && !mesmoEstabelecimento)
                            );

                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_solicitacoesalteracoesvts'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => {
                                    if ($state.href('meurh_solicitacoesalteracoesvts_not_found', $stateParams)) {
                                        $state.go('meurh_solicitacoesalteracoesvts_not_found', $stateParams);
                                    } else {
                                        $state.go('not_found', $stateParams);
                                    }
                                });
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

        $stateProvider
            .state('meurh_solicitacoesalteracoesvts', {
                url: '/solicitacoes/alteracoes-vts?q?tipo',
                template: require('html-loader!./index/solicitacoesalteracoesvts.index.html'),
                controller: 'Meurh\SolicitacoesalteracoesvtsIndexController',
                controllerAs: 'mrh_slctcsltrcsvts_lst_cntrllr',
                reloadOnSearch: false
            })
            .state('meurh_solicitacoesalteracoesvts_new', {
                parent: 'meurh_solicitacoesalteracoesvts',
                url: '/new',
                template: require('html-loader!./new/solicitacoesalteracoesvts.new.html'),
                controller: 'MeurhSolicitacoesalteracoesvtsNewController',
                controllerAs: 'mrh_slctcsltrcsvts_frm_nw_cntrllr'
            })
            .state('meurh_solicitacoesalteracoesvts_show', {
                parent: 'meurh_solicitacoesalteracoesvts',
                url: '/:solicitacao?path',
                resolve,
                template: require('html-loader!./show/solicitacoesalteracoesvts.show.html'),
                controller: 'MeurhSolicitacoesalteracoesvtsShowController',
                controllerAs: 'mrh_slctcsltrcsvts_frm_shw_cntrllr'
            })
            .state('meurh_solicitacoesalteracoesvts_edit', {
                parent: 'meurh_solicitacoesalteracoesvts',
                url: '/:solicitacao/edit',
                resolve,
                template: require('html-loader!./edit/solicitacoesalteracoesvts.edit.html'),
                controller: 'MeurhSolicitacoesalteracoesvtsEditController',
                controllerAs: 'mrh_slctcsltrcsvts_frm_edit_cntrllr'
            });
    }
];
